export default __webpack_public_path__ + "static/background-0b5bdde70381c3e618e65c21c773475e.webp";